<div class="p-4 search-form">
  <div class="d-flex justify-content-between mb-3 align-items-center">
    <h4 class="ff-poppins-semibold m-0" style="color: var(--secondary-color)">Search Your Car</h4>
    <div>
      <img
        style="cursor: pointer"
        (click)="onClose()"
        src="icons/ic_dialog_cross_btn.svg"
        alt="icon"
        (keyup.enter)="onClose()"
      />
    </div>
  </div>

  <div class="d-flex flex-wrap align-items-center">
    <div class="col-12 col-md-6 input-field pe-md-2 pb-3">
      <mat-form-field appearance="outline" class="filter-field w-100">
        <input
          matInput
          [min]="today"
          [(ngModel)]="formModel.pickupDate"
          (dateChange)="onChange($event, 'pickupDate')"
          [matDatepicker]="picker"
          placeholder="{{ 'Pick up date' | translate }}"
        />
        <mat-icon
          matSuffix
          style="color: var(--field-icon-color) !important"
          *ngIf="formModel.pickupDate"
          (click)="clear('pickupDate');$event.stopPropagation();"
          class="cursor-pointer"
          >clear</mat-icon
        >
        <mat-datepicker-toggle matIconPrefix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6 input-field ps-md-2 pb-3">
      <mat-form-field appearance="outline" class="filter-field w-100">
        <input
          matInput
          [matTimepicker]="timePicker"
          [(ngModel)]="formModel.pickupTime"
          (ngModelChange)="onTimeChange($event, 'pickupTime')"
          placeholder="{{ 'Time' | translate }}"
          [matTimepickerMin]="getCurrentTimeString() || null"
        />
        <mat-icon
          matSuffix
          style="color: var(--field-icon-color) !important"
          *ngIf="formModel.pickupTime"
          (click)="clear('pickupTime');$event.stopPropagation();"
          class="cursor-pointer"
          >clear</mat-icon
        >
        <mat-timepicker-toggle matIconPrefix [for]="timePicker"></mat-timepicker-toggle>
        <mat-timepicker #timePicker></mat-timepicker>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6 input-field pe-md-2 pb-3 pb-md-0">
      <mat-form-field appearance="outline" class="filter-field w-100">
        <input
          matInput
          [min]="formModel.pickupDate"
          [matDatepicker]="picker1"
          [(ngModel)]="formModel.dropoffDate"
          (dateChange)="onChange($event, 'dropoffDate')"
          placeholder="{{ 'Drop Off date' | translate }}"
        />
        <mat-icon
          matSuffix
          style="color: var(--field-icon-color) !important"
          *ngIf="formModel.dropoffDate"
          (click)="clear('dropoffDate');$event.stopPropagation();"
          class="cursor-pointer"
          >clear</mat-icon
        >
        <mat-datepicker-toggle matIconPrefix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6 input-field ps-md-2">
      <mat-form-field appearance="outline" class="filter-field w-100">
        <input
          matInput
          [matTimepicker]="timePicker1"
          [(ngModel)]="formModel.dropoffTime"
          (ngModelChange)="onTimeChange($event, 'dropoffTime')"
          placeholder="{{ 'Time' | translate }}"
          [matTimepickerMin]="getDropoffMinTime() || null"
        />
        <mat-icon
          matSuffix
          style="color: var(--field-icon-color) !important"
          *ngIf="formModel.dropoffTime"
          (click)="clear('dropoffTime');$event.stopPropagation();"
          class="cursor-pointer"
          >clear</mat-icon
        >
        <mat-timepicker-toggle matIconPrefix [for]="timePicker1"></mat-timepicker-toggle>
        <mat-timepicker #timePicker1></mat-timepicker>
      </mat-form-field>
    </div>

    <div class="col-12 d-grid mt-4" [ngClass]="{'mb-3': isCarNotAvailable}">
      <button
        type="button"
        mat-raised-button
        class="btn-submit"
        (click)="onUpdateLocationDetails()"
      >
        Search
      </button>
    </div>

    <mat-error *ngIf="isCarNotAvailable" class="text-center" style="font-size: 14px">
      This car is not available on your selected dates, please choose another car or change your
      schedule.
    </mat-error>
  </div>
</div>
